<!-- mat-icon -->
@if (1==tipoIcona) {
  <mat-icon [matBadge]="matBadge_value"
    [matBadgeColor]="matBadgeColor_value" [matBadgeSize]="matBadgeSize_value"
    [ngClass]="classValue" [fontSet]="fontsetValue" [attr.aria-label]="arialabelValue"
    [attr.aria-hidden]="ariahiddenValue" [attr.alt]="alt_value"
    [attr.id]="id_value">{{icon}}
  </mat-icon>
}

<!-- img -->
@if (2==tipoIcona) {
  <img [attr.src]="value_src" [attr.width]="widthValue" [attr.height]="heightValue"
    [attr.alt]="alt_value" [ngClass]="classValue">
}

<!-- SVG -->
@if (3==tipoIcona) {
  <mat-icon [svgIcon]="svgIconValue" [attr.aria-hidden]="ariahiddenValue"
  [attr.aria-label]="arialabelValue" [ngClass]="classValue"></mat-icon>
}
